function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import onClickOutside from "react-onclickoutside";
import { StyledLanguagePickerDialogComponent } from "./language-picker-dialog-component.scss";
import Dimensions from "../language-picker-dimensions";
import LanguagePickerItemComponent from "./language-picker-item/language-picker-item-component";
import { trackEvent } from "/services/bigbrain-service";
import { USER_SELECTED_LOCALE_ID_COOKIE } from "constants/localization";
import { LANGUAGE_PICKER_LANG_CHANGED } from "/constants/bigbrain-event-types";
import { setCookie } from "/services/cookies-service";
class LanguagePickerDialogComponent extends PureComponent {
    handleClickOutside() {
        const { closeDialog } = this.props;
        closeDialog();
    }
    getNumberOfLanguageItemsInColumn() {
        const { languages, maxElementsInColumn } = this.props;
        return languages.length <= maxElementsInColumn ? languages.length : Math.min(maxElementsInColumn, Math.ceil(languages.length / 2));
    }
    getComponentStyle() {
        return {
            height: this.getComponentHeight(),
            width: this.getComponentWidth()
        };
    }
    getComponentHeight() {
        const totalPadding = Dimensions.DIALOG_PADDING * 2;
        const numberOfElementsInColumn = this.getNumberOfLanguageItemsInColumn();
        const totalElementsHeight = Dimensions.LANGUAGE_ITEM_HEIGHT * numberOfElementsInColumn;
        const totaElementsPadding = Dimensions.LANGUAGE_ITEM_MARGIN * numberOfElementsInColumn * 2;
        return totalPadding + totalElementsHeight + totaElementsPadding;
    }
    getComponentWidth() {
        const { languages, maxElementsInColumn } = this.props;
        const totalPadding = Dimensions.DIALOG_PADDING * 2;
        const numberOfElementsInRow = Math.ceil(languages.length / maxElementsInColumn);
        const totalElelementsWidth = Dimensions.LANGUAGE_ITEM_WIDTH * numberOfElementsInRow;
        const totaElementsPadding = Dimensions.LANGUAGE_ITEM_MARGIN * numberOfElementsInRow * 2;
        return totalPadding + totalElelementsWidth + totaElementsPadding;
    }
    renderLanguageItems() {
        const { languages, selectedLanguageId } = this.props;
        return languages.map((language, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "language-picker-item-component-wrapper",
                children: /*#__PURE__*/ _jsx(LanguagePickerItemComponent, _object_spread_props(_object_spread({}, language), {
                    isSelected: selectedLanguageId === language.id,
                    onClick: this.onChangeLanguage
                }))
            }, index);
        });
    }
    render() {
        const style = this.getComponentStyle();
        return /*#__PURE__*/ _jsx(StyledLanguagePickerDialogComponent, {
            className: "language-picker-dialog-component",
            style: style,
            role: "listbox",
            children: this.renderLanguageItems()
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onChangeLanguage", (languageId)=>{
            const { selectedLanguageId, closeDialog } = this.props;
            closeDialog();
            if (selectedLanguageId !== languageId) {
                trackEvent(LANGUAGE_PICKER_LANG_CHANGED, {
                    info1: languageId,
                    info2: selectedLanguageId
                });
                setCookie(USER_SELECTED_LOCALE_ID_COOKIE, languageId);
                window.location.reload();
            }
        });
    }
}
LanguagePickerDialogComponent.defaultProps = {
    maxElementsInColumn: 5
};
export default onClickOutside(LanguagePickerDialogComponent);
